// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (max-width: 1199px) {
  /* Fuerza el acabado del botón que entrega Barra. trafico.css se carga en
     esta vista y puede tener selectores de botón más específicos. */
  body.trafico-oculto-responsive-page .trafico-oculto-page #layout-navbar .platform-navbar-menu-toggle,
  body.trafico-oculto-responsive-page .trafico-oculto-page #layout-navbar .platform-navbar-menu-toggle:hover,
  body.trafico-oculto-responsive-page .trafico-oculto-page #layout-navbar .platform-navbar-menu-toggle:focus,
  body.trafico-oculto-responsive-page .trafico-oculto-page #layout-navbar .platform-navbar-menu-toggle:focus-visible,
  body.trafico-oculto-responsive-page .trafico-oculto-page #layout-navbar .platform-navbar-menu-toggle:active {
    border: 0 !important;
    border-radius: 0 !important;
    background: transparent !important;
    background-color: transparent !important;
    background-image: none !important;
    box-shadow: none !important;
  }

  body.trafico-oculto-responsive-page #root {
    margin-left: 0 !important;
    overflow-x: hidden;
  }

  /* Mismo contrato visual que Control Device para Barra en pantallas compactas. */
  .trafico-oculto-page #layout-navbar.custom-navbar-admin {
    background: transparent !important;
    background-image: none !important;
    box-shadow: none !important;
  }

  .trafico-oculto-page #layout-navbar {
    min-height: 64px;
    padding: 4px 12px 4px 8px;
  }

  .trafico-oculto-page #layout-navbar .app-brand-link {
    min-width: 0;
    flex: 1 1 auto;
  }

  .trafico-oculto-page #layout-navbar .app-brand-link img {
    width: min(190px, 100%);
    height: 56px !important;
    object-fit: contain;
    object-position: left center;
  }

  .trafico-oculto-page #layout-navbar .navbar-nav-right {
    position: static;
    transform: none;
    flex: 0 0 auto;
  }

  /* Mismo panel lateral global usado por las demás vistas responsive. */
  body.trafico-oculto-responsive-page .sidenav---sidenav---_2tBP {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    z-index: 12000;
    width: 0;
    min-width: 0;
    overflow: hidden;
    transform: translateX(-100%);
    transition: width .2s ease, transform .2s ease;
  }

  body.trafico-oculto-responsive-page .sidenav---sidenav---_2tBP.sidenav---expanded---1KdUL {
    width: min(280px, 86vw);
    min-width: min(280px, 86vw);
    overflow-y: auto;
    transform: translateX(0);
    box-shadow: 8px 0 24px rgba(15, 39, 60, .22);
  }

  body.trafico-oculto-responsive-page .sidenav---sidenav---_2tBP.sidenav---expanded---1KdUL .sidenav---sidenav-toggle---1KRjR {
    display: block;
  }

  /* El control interno se mantiene para cerrar el panel, pero con el mismo
     acabado transparente de la hamburguesa global. */
  body.trafico-oculto-responsive-page .sidenav---sidenav-toggle---1KRjR,
  body.trafico-oculto-responsive-page .sidenav---sidenav-toggle---1KRjR:hover,
  body.trafico-oculto-responsive-page .sidenav---sidenav-toggle---1KRjR:focus,
  body.trafico-oculto-responsive-page .sidenav---sidenav-toggle---1KRjR:active {
    border: 0 !important;
    border-radius: 0 !important;
    background: transparent !important;
    background-color: transparent !important;
    background-image: none !important;
    box-shadow: none !important;
  }

  body.trafico-oculto-responsive-page .trafico-oculto-page .content-wrapper,
  body.trafico-oculto-responsive-page .trafico-oculto-page .container-fluid {
    min-width: 0;
  }
}

@media (max-width: 767px) {
  .trafico-oculto-page {
    min-height: 100dvh;
    overflow-x: hidden;
    background: #f5f7fb;
  }

  .trafico-oculto-page #layout-navbar {
    min-height: 60px;
    padding: 4px 8px;
  }

  .trafico-oculto-page #layout-navbar .app-brand-link img {
    width: min(172px, 100%);
    height: 48px !important;
  }
}

.trafico-oculto-loading {
  display: grid;
  min-height: 180px;
  place-items: center;
}

/* Se declara fuera del breakpoint porque esta vista puede renderizarse dentro
   de una ventana angosta aunque el viewport principal sea mayor. */
body.trafico-oculto-responsive-page .trafico-oculto-page #layout-navbar .platform-navbar-menu-toggle,
body.trafico-oculto-responsive-page .trafico-oculto-page #layout-navbar .platform-navbar-menu-toggle:hover,
body.trafico-oculto-responsive-page .trafico-oculto-page #layout-navbar .platform-navbar-menu-toggle:focus,
body.trafico-oculto-responsive-page .trafico-oculto-page #layout-navbar .platform-navbar-menu-toggle:active,
body.trafico-oculto-responsive-page .trafico-oculto-page #layout-navbar .platform-navbar-menu-toggle::before,
body.trafico-oculto-responsive-page .trafico-oculto-page #layout-navbar .platform-navbar-menu-toggle::after {
  border: 0 !important;
  border-radius: 0 !important;
  background: transparent !important;
  background-color: transparent !important;
  background-image: none !important;
  box-shadow: none !important;
}
`, "",{"version":3,"sources":["webpack://./src/Pages/Css/traficoOcultoResponsive.css"],"names":[],"mappings":"AAAA;EACE;oEACkE;EAClE;;;;;IAKE,oBAAoB;IACpB,2BAA2B;IAC3B,kCAAkC;IAClC,wCAAwC;IACxC,iCAAiC;IACjC,2BAA2B;EAC7B;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;EACpB;;EAEA,gFAAgF;EAChF;IACE,kCAAkC;IAClC,iCAAiC;IACjC,2BAA2B;EAC7B;;EAEA;IACE,gBAAgB;IAChB,yBAAyB;EAC3B;;EAEA;IACE,YAAY;IACZ,cAAc;EAChB;;EAEA;IACE,uBAAuB;IACvB,uBAAuB;IACvB,mBAAmB;IACnB,4BAA4B;EAC9B;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,cAAc;EAChB;;EAEA,sEAAsE;EACtE;IACE,eAAe;IACf,MAAM;IACN,SAAS;IACT,OAAO;IACP,cAAc;IACd,QAAQ;IACR,YAAY;IACZ,gBAAgB;IAChB,4BAA4B;IAC5B,8CAA8C;EAChD;;EAEA;IACE,uBAAuB;IACvB,2BAA2B;IAC3B,gBAAgB;IAChB,wBAAwB;IACxB,4CAA4C;EAC9C;;EAEA;IACE,cAAc;EAChB;;EAEA;qDACmD;EACnD;;;;IAIE,oBAAoB;IACpB,2BAA2B;IAC3B,kCAAkC;IAClC,wCAAwC;IACxC,iCAAiC;IACjC,2BAA2B;EAC7B;;EAEA;;IAEE,YAAY;EACd;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,uBAAuB;IACvB,uBAAuB;EACzB;AACF;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;mEACmE;AACnE;;;;;;EAME,oBAAoB;EACpB,2BAA2B;EAC3B,kCAAkC;EAClC,wCAAwC;EACxC,iCAAiC;EACjC,2BAA2B;AAC7B","sourcesContent":["@media (max-width: 1199px) {\n  /* Fuerza el acabado del botón que entrega Barra. trafico.css se carga en\n     esta vista y puede tener selectores de botón más específicos. */\n  body.trafico-oculto-responsive-page .trafico-oculto-page #layout-navbar .platform-navbar-menu-toggle,\n  body.trafico-oculto-responsive-page .trafico-oculto-page #layout-navbar .platform-navbar-menu-toggle:hover,\n  body.trafico-oculto-responsive-page .trafico-oculto-page #layout-navbar .platform-navbar-menu-toggle:focus,\n  body.trafico-oculto-responsive-page .trafico-oculto-page #layout-navbar .platform-navbar-menu-toggle:focus-visible,\n  body.trafico-oculto-responsive-page .trafico-oculto-page #layout-navbar .platform-navbar-menu-toggle:active {\n    border: 0 !important;\n    border-radius: 0 !important;\n    background: transparent !important;\n    background-color: transparent !important;\n    background-image: none !important;\n    box-shadow: none !important;\n  }\n\n  body.trafico-oculto-responsive-page #root {\n    margin-left: 0 !important;\n    overflow-x: hidden;\n  }\n\n  /* Mismo contrato visual que Control Device para Barra en pantallas compactas. */\n  .trafico-oculto-page #layout-navbar.custom-navbar-admin {\n    background: transparent !important;\n    background-image: none !important;\n    box-shadow: none !important;\n  }\n\n  .trafico-oculto-page #layout-navbar {\n    min-height: 64px;\n    padding: 4px 12px 4px 8px;\n  }\n\n  .trafico-oculto-page #layout-navbar .app-brand-link {\n    min-width: 0;\n    flex: 1 1 auto;\n  }\n\n  .trafico-oculto-page #layout-navbar .app-brand-link img {\n    width: min(190px, 100%);\n    height: 56px !important;\n    object-fit: contain;\n    object-position: left center;\n  }\n\n  .trafico-oculto-page #layout-navbar .navbar-nav-right {\n    position: static;\n    transform: none;\n    flex: 0 0 auto;\n  }\n\n  /* Mismo panel lateral global usado por las demás vistas responsive. */\n  body.trafico-oculto-responsive-page .sidenav---sidenav---_2tBP {\n    position: fixed;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    z-index: 12000;\n    width: 0;\n    min-width: 0;\n    overflow: hidden;\n    transform: translateX(-100%);\n    transition: width .2s ease, transform .2s ease;\n  }\n\n  body.trafico-oculto-responsive-page .sidenav---sidenav---_2tBP.sidenav---expanded---1KdUL {\n    width: min(280px, 86vw);\n    min-width: min(280px, 86vw);\n    overflow-y: auto;\n    transform: translateX(0);\n    box-shadow: 8px 0 24px rgba(15, 39, 60, .22);\n  }\n\n  body.trafico-oculto-responsive-page .sidenav---sidenav---_2tBP.sidenav---expanded---1KdUL .sidenav---sidenav-toggle---1KRjR {\n    display: block;\n  }\n\n  /* El control interno se mantiene para cerrar el panel, pero con el mismo\n     acabado transparente de la hamburguesa global. */\n  body.trafico-oculto-responsive-page .sidenav---sidenav-toggle---1KRjR,\n  body.trafico-oculto-responsive-page .sidenav---sidenav-toggle---1KRjR:hover,\n  body.trafico-oculto-responsive-page .sidenav---sidenav-toggle---1KRjR:focus,\n  body.trafico-oculto-responsive-page .sidenav---sidenav-toggle---1KRjR:active {\n    border: 0 !important;\n    border-radius: 0 !important;\n    background: transparent !important;\n    background-color: transparent !important;\n    background-image: none !important;\n    box-shadow: none !important;\n  }\n\n  body.trafico-oculto-responsive-page .trafico-oculto-page .content-wrapper,\n  body.trafico-oculto-responsive-page .trafico-oculto-page .container-fluid {\n    min-width: 0;\n  }\n}\n\n@media (max-width: 767px) {\n  .trafico-oculto-page {\n    min-height: 100dvh;\n    overflow-x: hidden;\n    background: #f5f7fb;\n  }\n\n  .trafico-oculto-page #layout-navbar {\n    min-height: 60px;\n    padding: 4px 8px;\n  }\n\n  .trafico-oculto-page #layout-navbar .app-brand-link img {\n    width: min(172px, 100%);\n    height: 48px !important;\n  }\n}\n\n.trafico-oculto-loading {\n  display: grid;\n  min-height: 180px;\n  place-items: center;\n}\n\n/* Se declara fuera del breakpoint porque esta vista puede renderizarse dentro\n   de una ventana angosta aunque el viewport principal sea mayor. */\nbody.trafico-oculto-responsive-page .trafico-oculto-page #layout-navbar .platform-navbar-menu-toggle,\nbody.trafico-oculto-responsive-page .trafico-oculto-page #layout-navbar .platform-navbar-menu-toggle:hover,\nbody.trafico-oculto-responsive-page .trafico-oculto-page #layout-navbar .platform-navbar-menu-toggle:focus,\nbody.trafico-oculto-responsive-page .trafico-oculto-page #layout-navbar .platform-navbar-menu-toggle:active,\nbody.trafico-oculto-responsive-page .trafico-oculto-page #layout-navbar .platform-navbar-menu-toggle::before,\nbody.trafico-oculto-responsive-page .trafico-oculto-page #layout-navbar .platform-navbar-menu-toggle::after {\n  border: 0 !important;\n  border-radius: 0 !important;\n  background: transparent !important;\n  background-color: transparent !important;\n  background-image: none !important;\n  box-shadow: none !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
